
<template>
  <input
    type="text"
    class="form-control input-datepicker"
		:id="'datepicker' + _uid"
		autocomplete="false"
  >
</template>

<script>
export default {
	
	props: ["value"],

    watch: {
        value() {
            this.montaInput();
        }
    },

	methods: {
    handleData(data) {
      this.$emit("input", data.split("/").reverse().join("-"));
    },

        montaInput() {
            let self = this

            setTimeout(() => {

                if(this.value != null)
                    $("#datepicker" + this._uid).val(this.value.split("-").reverse().join("/").toString())

                $("#datepicker" + this._uid).change(function(){
                    self.handleData($(this).val());
                });

                $(".input-datepicker").datetimepicker({
                    timepicker: false,
                    format: "d/m/Y",
                    formatDate: "d/m/Y",
                    scrollMonth: false,
                    scrollTime: false,
                    scrollInput: false
                });
            }, 100);
        }
  },
  mounted() {
		this.montaInput()
  }
};
</script>
